import React from 'react';
import { Layout } from '../components/sections/Layout';
import { InfrastructureStrip } from '../components/sections/InfrastructureStrip';
import { WhiteLabelSection } from '../components/sections/WhiteLabelSection';
import { FinalCTA } from '../components/sections/FinalCTA';
export function InfrastructurePage() {
  return <Layout data-id="element-791">
      <InfrastructureStrip data-id="element-792" />
      <WhiteLabelSection data-id="element-793" />
      <FinalCTA data-id="element-794" />
    </Layout>;
}